define('modules/ads/ads_filter_view',[
  'backbone',
  'jquery',
  '_',
  'URIjs/URI',
  'modules/list/list_view',
  'modules/loading/loading_spinner_view',
  'text!./ads_filter_template.html',
  './ads_filter_model',
  'session',
], function (
  Backbone,
  $,
  _,
  URI,
  ListView,
  Loading,
  AddFilterTemplate,
  AdsFilterModel,
  session
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.subViews = [];
      this.render();

      this.setupFilters();
      this.filterModel = new AdsFilterModel();

      this.listenTo(
        this.filterModel,
        'sync',
        function (model) {
          var i;
          if (this.zoneFilterControl) {
            var zoneOptions = model.get('zoneOptions');
            if (zoneOptions) {
              zoneOptions = zoneOptions.options;
            }

            for (i = 0; i < zoneOptions.length; i++) {
              this.zoneFilterControl[0].selectize.addOption({
                value: zoneOptions[i].id,
                text: zoneOptions[i].name,
              });
            }
          }

          if (this.playersFilterControl) {
            var playerOptions = model.get('playerOptions');
            if (playerOptions) {
              playerOptions = playerOptions.options;
            }

            for (i = 0; i < playerOptions.length; i++) {
              this.playersFilterControl[0].selectize.addOption({
                value: playerOptions[i].id,
                text: playerOptions[i].friendly_name
                  ? playerOptions[i].friendly_name +
                    ' (' +
                    playerOptions[i].name +
                    ')'
                  : playerOptions[i].name,
              });
            }
          }

          if (this.bookingTypeFilterControl) {
            var bookingTypeOptions = model.get('bookingTypeOptions');
            if (bookingTypeOptions) {
              bookingTypeOptions = bookingTypeOptions.options;
            }

            for (i = 0; i < bookingTypeOptions.length; i++) {
              this.bookingTypeFilterControl[0].selectize.addOption({
                value: bookingTypeOptions[i].bookingTypeFilter,
                text: bookingTypeOptions[i].label
              });
            }
          }

          return {};
        },
        this
      );

      this.filterModel.fetch();
    },

    filterModel: null,
    hasSidebar: false,
    subViews: [],

    zoneFilterControl: null,
    playersFilterControl: null,
    bookingTypeFilterControl: null,
    searchTextControl: '',
    filterTimer: null,

    template: _.template(AddFilterTemplate),

    events: {
      'keyup input#ads-search-field': 'onSearchTextChanged',
    },

    onSearchTextChanged: _.debounce(function () {
      var searchText = $('input#ads-search-field')[0].value;
      this.filterModel.set('searchText', searchText);
      this.filterModel.trigger('change', this.filterModel);
    }, 500),

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    setupFilters: function () {
      var that = this;

      this.zoneFilterControl = this.$('#ads_zones_search').selectize({
        maxItems: 1,
        mode: 'multi',
        closeAfterSelect: true,
        plugins: ['remove_button'],
        title: 'this',
        onChange: function () {
          that.triggerZoneFilterOptionChange();
        },
      });

      this.playersFilterControl = this.$('#ads_players_search').selectize({
        maxItems: 1,
        mode: 'multi',
        closeAfterSelect: true,
        plugins: ['remove_button'],
        onChange: function () {
          that.triggerPlayerFilterOptionChange();
        },
      });

      this.bookingTypeFilterControl = this.$('#ads_booking_type_search').selectize({
        maxItems: 1,
        mode: 'multi',
        closeAfterSelect: true,
        plugins: ['remove_button'],
        onChange: function () {
          that.triggerBookingTypeOptionChange();
        },
      });

      return this;
    },

    triggerZoneFilterOptionChange: function () {
      if (this.filterTimer) {
        clearTimeout(this.filterTimer);
      }
      var zoneOptions = this.filterModel.get('zoneOptions');
      zoneOptions.active = this.zoneFilterControl[0].selectize.items;
      this.filterModel.set('zoneOptions', zoneOptions);
      this.filterTimer = setTimeout(function () {
        this.filterModel.trigger('change', this.filterModel);
      }.bind(this), 1000);
    },

    triggerPlayerFilterOptionChange: function () {
      if (this.filterTimer) {
        clearTimeout(this.filterTimer);
      }
      var playerOptions = this.filterModel.get('playerOptions');
      playerOptions.active = this.playersFilterControl[0].selectize.items;
      this.filterModel.set('playerOptions', playerOptions);
      this.filterTimer = setTimeout(function () {
        this.filterModel.trigger('change', this.filterModel);
      }.bind(this), 1000);
    },

    triggerBookingTypeOptionChange: function () {
      if (this.filterTimer) {
        clearTimeout(this.filterTimer);
      }
      var bookingTypeOptions = this.filterModel.get('bookingTypeOptions');
      bookingTypeOptions.active = this.bookingTypeFilterControl[0].selectize.items;
      this.filterModel.set('bookingTypeOptions', bookingTypeOptions);
      this.filterTimer = setTimeout(function () {
        this.filterModel.trigger('change', this.filterModel);
      }.bind(this), 1000);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

